import { FunctionComponent, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { getCssVar } from '../../utils';
import { PinnedIcon } from '../PinnedIcon';

import classes from './ThreadBubble.module.scss';

interface ThreadBubbleProps {
  title: string;
  isPinnedToTopOfNewsFeed?: boolean;
  isPinnedToTopOfStory?: boolean;
  isTitleHeading?: boolean;
}

export const ThreadBubble: FunctionComponent<ThreadBubbleProps> = memo(
  ({ title, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, isTitleHeading }) => {
    const { t } = useTranslation();

    const { localiseKey } = useContext(ConfigContext).config.elements.card.thread;

    const TitleTag = isTitleHeading ? 'h2' : 'div';

    return (
      <div className={classes['thread']}>
        <div className={classes['thread__discussion']}>
          <PinnedIcon
            isPinnedToTopOfNewsFeed={Boolean(isPinnedToTopOfNewsFeed)}
            isPinnedToTopOfStory={Boolean(isPinnedToTopOfStory)}
            color={getCssVar('--card-thread-discussion-color')}
            showSeparator
          />
          {t(`${localiseKey ?? 'common.discussion'}`)}
        </div>
        {title && <TitleTag className={classes['thread__title']}>{title}</TitleTag>}
      </div>
    );
  }
);
